import { axios } from "../services/axios";
import {
  FORGOT_API,
  LOGIN_API,
  LOGOUT,
  RESEND_CODE,
  RESET_API,
  VERIFICATION,
  SIGN_UP_API,
  VERIFY_EMAIL_API,
  STATE_LIST,
  REFRESH_TOKEN,
  CREATE_API,
  INSPECTOR_LIST,
  NOTIFICATION_LIST,
  NOTIFICATION_COUNT,
  READ_NOTIFICATION,
} from "../constants/paths";

/**
 * Login DTO
 * @export
 * @typedef {LoginCredentialsDTO}
 */
export type LoginCredentialsDTO = {
  email: string;
  password: string;
  role: any;
};

/**
 * MFA Code DTO
 * @export
 * @typedef {LoginVerificationCodeDTO}
 */
export type LoginVerificationCodeDTO = {
  code: number;
  user_id: number;
};

/**
 * MFA Code DTO
 * @export
 * @typedef {ResetPasswordDTO}
 */
export type ResetPasswordDTO = {
  password: string;
  token: string;
};

/**
 * MFA Code DTO
 * @export
 * @typedef {LogoutDTO}
 */
export type LogoutDTO = {
  refreshToken: string;
};

/**
 * MFA Code DTO
 * @export
 * @typedef {ForgotPasswordDTO}
 */
export type ForgotPasswordDTO = {
  email: string;
  from: string;
};

/**
 * Resend MFA Code DTO
 * @export
 * @typedef {ResendMFACodeDTO}
 */
export type ResendMFACodeDTO = {
  user_id: number;
};

/**
 * Login API Call
 * @param {LoginCredentialsDTO} data
 * @returns {Promise<any>}
 */
export const loginWithUserNameAndPassword = (
  data: LoginCredentialsDTO
): Promise<any> => {
  return axios.post(LOGIN_API, data);
};

/**
 * MFA Authentication API Call
 * @param {LoginCredentialsDTO} data
 * @returns {Promise<any>}
 */

export const loginWithVerificationCode = (
  data: LoginVerificationCodeDTO
): Promise<any> => {
  return axios.post(VERIFICATION, data);
};

/**
 * Forgot Password API Call
 * @param {ForgotPasswordDTO} data
 * @returns {Promise<any>}
 */
export const forgotPassword = (data: ForgotPasswordDTO): Promise<any> => {
  return axios.post(FORGOT_API, data);
};

/**
 * Reset Password API Call
 *
 * @param {ResetPasswordDTO} data
 * @returns {Promise<any>}
 */
export const resetPassword = (data: ResetPasswordDTO): Promise<any> => {
  const formdata = { password: data.password };
  return axios.post(RESET_API + data.token, formdata);
};

/**
 * Create Password API Call
 *
 * @param {ResetPasswordDTO} data
 * @returns {Promise<any>}
 */
export const createPassword = (data: ResetPasswordDTO): Promise<any> => {
  const formdata = { password: data.password };
  return axios.post(CREATE_API + data.token, formdata);
};

/**
 * Logout API Call
 * @param {LogoutDTO} data
 * @returns {Promise<any>}
 */
export const logout = (data: LogoutDTO): Promise<any> => {
  return axios.post(LOGOUT, data);
};

/**
 * Resend MFA Code API Call
 *
 * @returns {Promise<any>}
 */
export const resendMFACode = (data: ResendMFACodeDTO): Promise<any> => {
  return axios.post(RESEND_CODE, data);
};

/**
 * SingUp DTO
 * @export
 * @typedef {userSignUpDTO}
 */
// export type userSignUpDTO = {
//     formData:any
// }
export type userSignUpDTO = {
  first_name: String;
  last_name: String;
  email: String;
  company_name: String;
  phone: String;
  cell_number: String;
  address: String;
  role: String;
  city: String;
  state: String;
  zip_code: String;
  password: String;
  billing_contact_name: String;
  billing_contact_email: String;
  billing_cell_number: String;
  billing_address: String;
  billing_state: String;
  billing_zip: String;
  billing_city: String;
  yard_zip: String;
  yard_city: String;
  yard_address: String;
  yard_state: String;
  decal_email: String;
  decal_contact: String;
  decal_cell: String;
  decal_address: String;
  decal_zip: String;
  decal_state: String;
  decal_city: String;
};

/**
 * SignUp API Call
 * @param {userSignUpDTO} data
 * @returns {Promise<any>}
 */
export const userSignUp = (data: userSignUpDTO): Promise<any> => {
  return axios.post(SIGN_UP_API, data);
};

/**
 * Verify Email DTO
 * @export
 * @typedef {VerifyEmailDTO}
 */
export type VerifyEmailDTO = {
  token: string;
};

/**
 * Verify Email API Call
 *
 * @param {VerifyEmailDTO>}
 */
export const verifyEmail = (data: VerifyEmailDTO): Promise<any> => {
  return axios.post(VERIFY_EMAIL_API + data.token);
};

/**
 * State List API Call
 *
 * @param {VerifyEmailDTO>}
 */
export const getStateList = () => {
  return axios.get(STATE_LIST);
};

/**
 * Refresh Token API
 *
 * @param {LogoutDTO} data
 * @returns {Promise<any>}
 */
export const refreshTokenCALL = (data: LogoutDTO): Promise<any> => {
  return axios.post(REFRESH_TOKEN, data);
};

/**
 * Inspector List with other status API Call
 * @returns {Promise<any>}
 */
export const getInspectorsApiCall = (): Promise<any> => {
  return axios.get(INSPECTOR_LIST);
};

//Get a notification list by user id
export const getNotificationList = async (params) => {
  return await axios.get(NOTIFICATION_LIST, {
    params: params,
  });
};

//Get a new notification count by user id
export const getNewNotificationCount = async (params): Promise<any> => {
  return await axios.get(NOTIFICATION_COUNT, {
    params: params,
  });
};

//Mark notification as read by user id
export const markNotificationRead = async (params) => {
  return await axios.get(READ_NOTIFICATION, {
    params: params,
  });
};
